export enum AdminAclEnum {
    ADMIN = 'admin',
    USERS = 'users',
    INFLUENCERS = 'influencers',
    CAMPAIGNS = 'campaigns',
    SUPERVISORS = 'supervisors',
    OFFERS = 'offers',
    ACCESS_RIGHTS = 'access_rights',
    PACKAGES = 'packages',
    EXPORT = 'export',
    EMAILING = 'emailing',
    BUDGET = 'budget_overview',
    AGENCY = 'agency',
    REPORTING = 'reporting',
    ONBOARDING = 'onboarding',
    STATISTICS = 'statistics',
    COMPANY = 'company',
    INVOICES = 'invoices',
    PLATFORM = 'platform',
    USER_PLATFORM_LOGS = 'user_platform_logs',
    REPORT_ITEMS = 'report_items',
    CONTRACTS = 'contracts',
    DISCOVERY = 'discovery',
    LOGS = 'logs',
    INVOICE_ACTION = 'invoice_action',
    INVOICE_VERIFICATION = 'invoice_verification',
    CHANGE_USER_ROLES = 'change_user_roles',
    MODASH_CHECK = 'modash_check',
    INFLUENCER_FEE = 'influencer_fee',
    DISCOVERY_PRESET = 'discovery_preset',
    ADD_ADDITIONAL_ITEM = 'add_additional_item',
    CONTROLLING = 'controlling',
    CONTROLLING_INCOMING_DEFERRAL = 'controlling_incoming_deferral',
    CONTROLLING_INCOMING_INVOICES = 'controlling_incoming_invoices',
    CONTROLLING_OUTGOING_INVOICES = 'controlling_outgoing_invoices',
    CONTROLLING_LONG_TERM_INCOMING_INVOICES = 'controlling_long_term_incoming_invoices',
    CONTROLLING_KPIS = 'controlling_kpis',
    CONTROLLING_AGENCY_REVENUE_CAMPAIGNS = 'controlling_agency_revenue_campaigns',
    CONTROLLING_AGENCY_REVENUE_COMPANIES = 'controlling_agency_revenue_companies',
    INFLUENCER_FEE_OVERVIEW = 'influencer_fee_overview',
    COMPANY_GROUPS_VIEW = 'company_groups_view',
    COMPANY_GROUPS_EDIT = 'company_groups_edit',
    BRAND_USER_ACCESS_RIGHTS = 'brand_user_access_rights',
    OFFER_PDFS = 'offer_pdfs',
    CONTRACT_PDFS = 'contract_pdfs',
    REGENERATE_PDF = 'regenerate_pdf',
    OFFER_OVERVIEW = 'offer_overview',
    CONTRACT_OVERVIEW = 'contract_overview',
    USER_ADVANCED_EDIT = 'user_advanced_edit',
    CAMPAIGN_ADVANCED_EDIT = 'campaign_advanced_edit',
    OFFER_EVENT_TRANSFER = 'offer_event_transfer',
}
